import { Link } from "react-router-dom";
import type { Anime } from "@/mocks/anime";

export default function AnimeCard({ anime }: { anime: Anime }) {
  return (
    <Link
      to={`/anime/${anime.id}`}
      className="group flex flex-col overflow-hidden rounded-2xl border border-background-200/70 bg-background-100 transition-all hover:-translate-y-1 hover:border-primary-200"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden">
        <img
          src={anime.cover}
          alt={`${anime.name} 海报封面`}
          loading="lazy"
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 top-0 flex items-center justify-between p-3">
          <span className="rounded-full bg-background-950/50 px-2.5 py-1 text-xs text-background-50 backdrop-blur">
            {anime.category}
          </span>
          <span className="inline-flex items-center gap-0.5 rounded-full bg-primary-500 px-2 py-1 text-xs font-semibold text-background-50">
            <i className="ri-star-fill text-[10px]" aria-hidden="true" />
            {anime.rating.toFixed(1)}
          </span>
        </div>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-background-950/70 to-transparent p-3 pt-8">
          <span className="text-xs text-background-50">
            {anime.episodeCount} 集 · 单集约 {anime.episodeMin} 分钟
          </span>
        </div>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="font-heading text-lg text-foreground-950">{anime.name}</h3>
        <p className="mt-1.5 line-clamp-2 text-sm leading-5 text-foreground-600">{anime.desc}</p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {anime.tags.map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}